import React from "react";
import { Helmet } from "react-helmet-async";
import PageWrapper from "../components/PageWrapper";

const serviceGrid = [
  {
    title: "Dekoracja światłem",
    image: "/assets/zamkniete/zamkniete7.webp",
    description:
      "Marzy Ci się rustykalne wesele, elegancka gala albo klimatyczny koncert pod gołym niebem? Z nami to możliwe! Tworzymy niezapomniane przestrzenie dzięki profesjonalnej oprawie świetlnej – od dekoracyjnego światła na weselach po widowiskowe oświetlenie sceniczne. Niezależnie od stylu wydarzenia, zadbamy o każdy detal i klimat. To nie tylko tło – to serce atmosfery Twojej imprezy.",
  },
  {
    title: "Taniec w chmurach",
    image: "/assets/zamkniete/zamkniete5.webp",
    description:
      "Jeśli chcesz, by Wasz pierwszy taniec był naprawdę wyjątkowy – wybierz taniec w chmurach. Dzięki profesjonalnej wytwornicy ciężkiego dymu stworzymy efekt bajecznych obłoków unoszących się nad parkietem. Idealny również do podziękowań dla rodziców czy wprowadzenia tortu. Sprzęt najwyższej klasy i klimat, którego nie zapomnicie.",
  },
  {
    title: "Nagłośnienie ślubu plenerowego",
    image: "/assets/zamkniete/zamkniete22.webp",
    description:
      "Ślub pod gołym niebem? Zadbamy o to, by każda przysięga i dźwięk były wyraźne i wzruszające. Oferujemy profesjonalne nagłośnienie ceremonii – z muzyką, mikrofonami i realizatorem na miejscu. Dźwięk dopasowany do nastroju i miejsca – Twoja przysięga będzie brzmiała idealnie, niezależnie od otoczenia.",
  },
  {
    title: "Pirotechnika sceniczna",
    image: "/assets/otwarte/otwarte6.webp",
    description:
      "Fontanny iskier, wyrzutnie CO₂ i zsynchronizowane efekty specjalne. Pirotechnika to kulminacyjne emocje na Twojej imprezie – idealne na pierwszy taniec, wejście na salę czy moment kulminacyjny. Efekt wow gwarantowany, a przy tym bezpieczny i zgodny ze scenariuszem wydarzenia. Tworzymy show, które zostaje w pamięci.",
  },
];

export default function Oferta() {
  return (
    <PageWrapper>
      <Helmet>
        <title>Oferta – DJ Kusy | Wesele, studniówka, event firmowy</title>
        <meta
          name="description"
          content="Wybierz ofertę DJ Kusego i zaskocz swoich gości! Profesjonalna muzyka, efekty specjalne, światła i prowadzenie imprez – wszystko, by Twoje wydarzenie było wyjątkowe. Sprawdź, jak możemy razem stworzyć niezapomnianą atmosferę!"
        />
        <link rel="canonical" href="https://djkusy.pl/oferta" />
        <meta property="og:title" content="DJ Kusy – Oferta dla Twojej imprezy" />
        <meta property="og:description" content="Wybierz pakiet dopasowany do Twojego wydarzenia: wesele, event, urodziny. Profesjonalny DJ z klasą." />
        <meta property="og:image" content="https://djkusy.pl/og-image.webp" />
        <meta property="og:url" content="https://djkusy.pl/oferta" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />

        {/* Breadcrumbs structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Strona główna",
                "item": "https://djkusy.pl/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Oferta",
                "item": "https://djkusy.pl/oferta"
              }
            ]
          })}
        </script>

        {/* WebPage structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Oferta",
            "url": "https://djkusy.pl/oferta",
            "description": "Oferta DJ-a: oprawa muzyczna, światła, efekty specjalne, prowadzenie imprez. Kompleksowa obsługa na wesele, event, urodziny.",
            "inLanguage": "pl-PL"
          })}
        </script>
      </Helmet>

      {/* HERO */}
      <section
        id="hero"
        className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6 bg-cover bg-center text-white relative"
        style={{ backgroundImage: "url('/assets/otwarte/otwarte2.webp')" }}
      >
        <div className="absolute inset-0 bg-black opacity-60" />
        <div className="relative z-10 max-w-3xl">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-6">Oferta</h1>
          <p className="text-lg md:text-xl leading-relaxed text-gray-200">
            Mamy wszystko co pozwoli na zorganizowanie wyjątkowego i niezapomnianego wydarzenia.
          </p>
        </div>
      </section>

      {/* CO POSIADAM */}
      <section className="bg-white py-20 px-6 text-center max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">Co posiadam?</h2>
        <p className="text-lg text-gray-700 leading-relaxed">
          Posiadam kompletny zestaw nowoczesnego sprzętu muzycznego, oświetleniowego i multimedialnego, który pozwala zrealizować każde wydarzenie – od eleganckiego wesela, przez plenerowy ślub, aż po dynamiczne eventy firmowe i koncerty. Dysponuję również wyjątkowymi atrakcjami scenicznymi i efektami specjalnymi, które podnoszą jakość i emocjonalny poziom każdej imprezy. To właśnie dzięki temu mogę zaoferować usługi dopasowane do każdej okazji.
        </p>
      </section>

      {/* USŁUGI */}
      <section className="text-left px-4 sm:px-8 max-w-7xl mx-auto pt-12 pb-24">
        <div className="flex flex-col gap-20">
          {serviceGrid.map(({ title, image, description }, i) => (
            <div
              key={i}
              className="transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl hover:border-orange-500 flex flex-col md:flex-row items-center md:items-start bg-gradient-to-b from-[#0b1117] to-[#0e151b] border border-[#1f2937] rounded-3xl p-6 md:p-12 gap-8 md:gap-12 shadow-xl text-white"
            >
              <div className="w-full md:w-1/2 rounded-2xl overflow-hidden">
                <img
                  src={image}
                  alt={title}
                  className="w-full h-full object-cover rounded-2xl transform transition-transform duration-500 hover:scale-105"
                />
              </div>
              <div className="w-full md:w-1/2 flex flex-col justify-center">
                <h3 className="text-3xl md:text-5xl font-extrabold tracking-tight mb-6">
                  {title}
                </h3>
                <p className="text-lg md:text-xl text-gray-300 leading-relaxed">
                  {description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </PageWrapper>
  );
}
